import { Box, Flex, Image, Heading, Button, Text } from '@chakra-ui/react';
import {
    GetStartedContainer,
    RoundImage,
} from '../../components/LandingPageComponents/styles/SplashStyles';
import logo from '../../assets/newLogo.svg';
import one from '../../assets/getstarted1.png';
import two from '../../assets/getstarted2.png';
import three from '../../assets/getstarted3.png';
import smiley from '../../assets/smiley.svg';
import star from '../../assets/starLeft.svg';
import star2 from '../../assets/starRight.svg';
import diamond from '../../assets/diamong.svg';
import yay from '../../assets/yay.svg';
import crown from '../../assets/crown.svg';
import arrowDown from '../../assets/arrowDown.svg';
import splashImg from '../../assets/getstarted4.svg';
import giftBox from '../../assets/giftBox.svg';
import flash from '../../assets/flash.svg';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Link } from 'react-router-dom';
import percent from '../../assets/percent.png';
const GetStarted = () => {
    return (
        <GetStartedContainer>
            <Flex
                w="full"
                h="full"
                minH="max-content"
                justify="center"
                alignItems="center"
                flexDir="column"
                position={'relative'}>
                <Link to="/" style={{ width: '100%', textAlign: 'center' }}>
                    <Image src={logo} alt="logo" mb="30px" />
                </Link>
                <Carousel
                    showArrows={false}
                    showStatus={false}
                    infiniteLoop
                    useKeyboardArrows
                    autoPlay
                    className="carousl">
                    <Box margin="auto" w="95vw">
                        <Box margin="auto" w="100%" h="320px">
                            <Image src={splashImg} alt="getstarted img2" />
                        </Box>
                        <Heading as="h3">
                            Increase Your Margins with Unbeatable Wholesale Prices
                        </Heading>
                    </Box>
                    <Box margin="auto" w="95vw">
                        <Box
                            h={'119.19px'}
                            w="122px"
                            style={{
                                position: 'fixed',
                                marginLeft: '-2.1rem',
                                top: '0',
                                zIndex: '999999999',
                            }}>
                            <Image src={star} alt="getstarted img3" />
                        </Box>
                        <Box margin="auto" w="100%" h="320px" position={'relative'}>
                            <div>
                                <RoundImage>
                                    <Image src={two} alt="getstarted img2" />
                                </RoundImage>
                                <Box marginTop={'-35px'} marginLeft={'24px'} h="36px" w="36px">
                                    <Image src={smiley} alt="getstarted img3" />
                                </Box>
                                <Box
                                    h={'119.19px'}
                                    w="122px"
                                    style={{
                                        position: 'absolute',
                                        marginRight: '-2.5rem',
                                        bottom: '-2rem',
                                        right: '0',
                                        zIndex: '999999999',
                                    }}>
                                    <Image src={star2} alt="getstarted img3" />
                                </Box>
                            </div>
                        </Box>
                        <Heading as="h3">
                            Increase Your Margins with Unbeatable Wholesale Prices
                        </Heading>
                    </Box>
                    <Box margin="auto" w="95vw" position={'relative'}>
                        <Box
                            h={'69.6px'}
                            style={{
                                position: 'absolute',
                                top: '0',
                                right: '0',
                                zIndex: '999999999',
                            }}>
                            <Image src={yay} alt="getstarted img3" />
                        </Box>
                        <Box margin="auto" w="100%" h="320px">
                            <RoundImage>
                                <Image src={one} alt="getstarted img1" />
                            </RoundImage>
                            <Box marginTop={'-35px'} marginLeft={'24px'} h="36px" w="36px">
                                <Image src={diamond} alt="getstarted img3" />
                            </Box>
                        </Box>
                        <Heading as="h3">You Can Track Your Earnings From Your Wallet </Heading>
                    </Box>
                    <Box margin="auto" w="95vw" position={'relative'}>
                        <Box
                            h={'44.35px'}
                            w={'58px'}
                            style={{
                                position: 'absolute',
                                top: '0',
                                right: '43.03px',
                                zIndex: '999999999',
                            }}>
                            <Image src={crown} alt="getstarted img3" />
                        </Box>
                        <Box margin="auto" w="100%" h="320px">
                            <RoundImage>
                                <Image src={three} alt="getstarted img3" className="last-img" />
                            </RoundImage>
                            <Box marginTop={'-35px'} marginLeft={'24px'} h="44.04px" w="45.9px">
                                <Image src={arrowDown} alt="getstarted img3" />
                            </Box>
                        </Box>
                        <Heading as="h3">Get The Best Deals and Shopping Experience </Heading>
                    </Box>
                    <Box margin="auto" w="95vw" position={'relative'} pt="3.5">
                        <Box
                            h={'44.6px'}
                            w={'36px'}
                            style={{
                                position: 'absolute',
                                top: '0rem',
                                right: '14px',
                                zIndex: '999999999',
                            }}>
                            <Image src={flash} alt="getstarted img3" />
                        </Box>
                        <Box
                            margin="auto"
                            w="95%"
                            maxWidth={'324px'}
                            h="292px"
                            p="1rem"
                            bgColor="white"
                            borderRadius="16px"
                            bgImage={percent}
                            bgRepeat="no-repeat"
                            bgSize="contain">
                            <Text
                                textTransform="uppercase"
                                mt="1rem"
                                textAlign="center"
                                fontSize="12px"
                                lineHeight="16px">
                                Popular
                            </Text>
                            <Heading
                                as="h4"
                                mt="0"
                                mb="5px"
                                color="#090A0A"
                                fontSize="18px"
                                textAlign="center"
                                lineHeight="24px">
                                Earn up to
                            </Heading>
                            <Heading
                                as="h4"
                                mt="20px"
                                mb="15px"
                                color="#1b3b5f"
                                fontSize="48px"
                                textAlign="center"
                                lineHeight="56px"
                                fontWeight="700">
                                3%
                            </Heading>
                            <Text
                                textAlign="center"
                                opacity=".55"
                                fontSize="14px"
                                lineHeight="20px"
                                pb="1rem">
                                On Every Sale
                            </Text>
                            <Link to="/register">
                                <Button className="btn" w="80%">
                                    Proceed to Get Started
                                </Button>
                            </Link>
                        </Box>
                        <Box marginTop={'-15px'} marginLeft={'24px'} h="49.2px" w="46px">
                            <Image src={giftBox} alt="getstarted img3" />
                        </Box>
                        <Heading as="h3">Join Obana Today & Get Commissions on Each Sale</Heading>
                    </Box>
                </Carousel>
                <Link to="/register">
                    <Button>Create Account</Button>
                </Link>

                <Text mt="20px">
                    Have an account? <Link to="/login">Log in</Link>
                </Text>
            </Flex>
        </GetStartedContainer>
    );
};

export default GetStarted;
